import http from "@/common/http"

export const detail = (id) =>{
  return http({
    url:"/cont/strategy/detail",
    method:"get",
    data:{
      id
    }
  })
}

export const list = (data) =>{
  return http({
    url:"/cont/strategy/list",
    method:"post",
    data:data
  })
}

export const relationList = (data) =>{
  return http({
    url:"/cont/strategy/relationlist",
    method:"post",
    data:data
  })
}

export default {
  relationList,
  detail,
  list
}



// WEBPACK FOOTER //
// ./src/services/client/cont/strategy.js